export default "__VITE_ASSET__609ef4d1__"